import api from "./api";

export default {
    async updateCompany(companyId) {
        const data = {
            page: companyId
        };

        return await api.put(`/v1/pages/0/active`, data);
    },

    // Admin-only: search all bedrijfspaginas (role==admin gated backend-side).
    async searchPages(searchTerm = "") {
        return await api.get(
            `/v1/pages/0/searchpage?search=${encodeURIComponent(searchTerm)}`
        );
    }
}